import React from 'react';
import * as Yup from 'yup';
import { withFormik, Field } from 'formik';
import { Form, Button } from 'semantic-ui-react';
import { withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { map, times, isEmpty } from 'lodash';
import { urlRegex, ipRegex } from './regex';

import { HHUrl, HHInput, HHCheckbox, HHSingleSelect, HHTinyMCE } from './fields';
import { FORM_NAME } from '../forms/formConstant';
import { signIn } from '../actions';

const formikEnhancer = withFormik({
  validationSchema: ({ translate }) => Yup.object().shape({
    name: Yup
      .string().min(1, translate('form.error.string.min'))
      .max(60, translate('form.error.string.max'))
      .required(translate('form.error.mixed.required')),
    prize: Yup.string(),
    websiteUrl: Yup
      .string().min(10, translate('form.error.string.min')).max(200, translate('form.error.string.max'))// .url(translate('form.error.string.url'))
      .test(
        'validUrl',
        translate('form.error.string.url'),
        // eslint-disable-next-line func-names, prefer-arrow-callback
        function (value) { return !value || urlRegex.test(value) || ipRegex.test(value); }
      ),
    default: Yup.boolean(),
    limit: Yup
      .number()
      .required(translate('form.error.mixed.required'))
  }),
  mapPropsToValues: (props) => (props.initialValues),
  handleSubmit: (values, { props }) => {
    props.handleSubmit(values);
  },
  displayName: FORM_NAME.LOGIN_FORM
});

const AwardForm = (props) => {
  const {
    handleCancel,
    handleSubmit,
    isSubmitting,
    isEditing,
    translate,
    slug,
    userToken, errors
  } = props;

  return (
    <Form
      onSubmit={handleSubmit}
      className='cms-awards_form cms-awards_table_item_description'
    >
      <div className='cms-awards_form_formGroup'>
        <Form.Field>
          <label htmlFor='name'>{translate('award.name.required')}</label>
          <Field
            name='name'
            component={HHInput}
            otherProps={{
              type: 'text',
              id: 'name',
              maxLength: 60,
              minLength: 1
            }}
          />
        </Form.Field>

        <Form.Field>
          <label htmlFor='prize'>{translate('description')}</label>
          {/* <Field
            name='prize'
            component={HHTextArea}
            otherProps={{
              id: 'prize',
              type: 'text'
            }}
          /> */}
          <Field
            name='prize'
            component={HHTinyMCE}
            fileType='event_award_description'
            slug={slug}
            userToken={userToken}
            // otherProps={{
            //   id: 'prize',
            //   type: 'text'
            // }}
          />
        </Form.Field>

        <Form.Field>
          <label htmlFor='websiteUrl'>{translate('website.url')}</label>
          <Field
            name='websiteUrl'
            component={HHUrl}
            otherProps={{
              id: 'websiteUrl',
              type: 'text'
            }}
          />
        </Form.Field>

        <Form.Field className='cms-awards_form_mandatoryPrize'>
          <label htmlFor='default'>{translate('mandatory.prize')}?</label>
          <Field
            name='default'
            component={HHCheckbox}
            otherProps={{
              type: 'checkbox',
              toggle: true
            }}
          />
        </Form.Field>
      </div>

      <Form.Field className='cms-awards_form_limit'>
        <label htmlFor='limit'>{translate('limit')}</label>
        <Field
          name='limit'
          component={HHSingleSelect}
          otherProps={{
            id: 'limit',
            simpleValue: true,
            searchable: false,
            clearable: false,
            options: map(times(50, x => x + 1), y => ({ value: y, label: y })),
            placeholder: 'ordering...'
          }}
        />
      </Form.Field>

      <div className='cms-awards_form_btnGroup'>
        {handleCancel && (
          <Button
            basic
            type='button'
            onClick={handleCancel}
            className='cms-awards_form_btnGroup_btn-cancel'
          >
            {translate('cancel')}
          </Button>
        )}
        <Button
          loading={isSubmitting}
          primary
          disabled={isSubmitting || !isEmpty(errors)}
          className='cms-awards_form_btnGroup_btn-submit'
          type='submit'
        >
          {isEditing ? translate('save') : translate('create')}
        </Button>
      </div>
    </Form>
  );
};

export default compose(
  withLocalize,
  connect(null, { signIn }),
  formikEnhancer
)(AwardForm);



// WEBPACK FOOTER //
// ./src/components/forms/awardForm.js